import * as React from "react";
import { Controller } from "react-hook-form";
import { Autocomplete as MuiAutocomplete, TextField } from "@mui/material";
import { InputProps } from "../form/form";
import { OrganizationId } from "../../domain/organization";
import { useOrganizationClubsForAutocomplete } from "../../hooks/clubs";
import {
    isLoadingState,
    queryStateData,
} from "../../utils/supabase/QueryState";
import { emptyArray } from "../../utils/fp";
import { array, option } from "fp-ts";
import { pipe } from "fp-ts/function";

interface Props extends InputProps {
    label: React.ReactNode;
    organizationId: Nullable<OrganizationId>;
    fullWidth?: boolean;
}

const ClubAutocompleteInner = (
    p: Props,
    _ref: React.ForwardedRef<HTMLDivElement>
) => {
    const clubsQuery = useOrganizationClubsForAutocomplete(p.organizationId);
    const options = pipe(
        clubsQuery.state,
        queryStateData,
        option.map(array.map((club) => club.title)),
        option.getOrElse(emptyArray())
    );

    return (
        <Controller
            name={p.name}
            control={p.control}
            render={({ field }) => (
                <MuiAutocomplete
                    freeSolo
                    autoSelect // important for free solo!
                    loading={isLoadingState(clubsQuery.state)}
                    value={field.value || null}
                    options={options}
                    onChange={(event, newVal) => {
                        field.onChange(newVal);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            required={p.required}
                            helperText={p.helperText}
                            error={p.error}
                            label={p.label}
                            fullWidth={p.fullWidth}
                        />
                    )}
                />
            )}
        />
    );
};

export const ClubAutocomplete = React.forwardRef(ClubAutocompleteInner);
